export default __webpack_public_path__ + "static/media/attic-reverse.c4414c90.mp4";